module.exports = __webpack_public_path__ + "static/media/strop-za-oltarem.01a8d30c.jpg";